import { render, staticRenderFns } from "./SetNovoResponsavel.vue?vue&type=template&id=4ac73b30"
import script from "./SetNovoResponsavel.vue?vue&type=script&lang=js"
export * from "./SetNovoResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports